<template>
  <v-dialog v-model="dialog" persistent width="500">
    <common-card>
      <v-card-text class="pa-4 black--text" style="text-align: center;">
        <div class="pt-5 pb-5 top-text text-data-details">
          Seleccionar motivo de cancelación.
        </div>

        <div class="pt-5 pb-5">
          <v-row class="pt-5">
            <v-col cols="12">
              <v-combobox
                v-model="motivoSeleccionado"
                :items="motivos"
                label="Motivo"
                outlined
                dense
              ></v-combobox>
            </v-col>

            <v-col cols="12" v-if="motivoSeleccionado === 'Otro'">
              <v-text-field
                v-model="motivoOtro"
                label="Especificar otro motivo"
                outlined
                dense
                :rules="[$rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col cols="6">
            <v-btn
              text
              color="#00a7e4"
              outlined
              dark
              style="border-radius: 15px;"
              @click="emitir(false)"
            >
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              class="common-botton"
              dark
              @click="emitir(true)"
              :disabled=" !motivoSeleccionado || (motivoSeleccionado === 'Otro' && !motivoOtro)"
            >
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </common-card>
  </v-dialog>
</template>

<script>
import CommonCard from "./CommonCard.vue";
import { mainAxios } from "@/mainAxios.js";

export default {
  components: { CommonCard },
  props: {
    dialog: Boolean
  },
  data() {
    return {
      motivoSeleccionado: null,
      motivoOtro: "",
      motivos: []
    };
  },
  mounted() {
    this.obtenerMotivos();
  },
  methods: {
    emitir(confirmado) {
      const motivoFinal = this.motivoSeleccionado === "Otro" ? this.motivoOtro : this.motivoSeleccionado;
      this.$emit("cerrar", confirmado, {
        motivo: motivoFinal
      });
    },
    obtenerMotivos(){
        const config = {
          headers: {
            Authorization: "Bearer " + localStorage.agenteAccessToken,
          },
        };
        mainAxios.get(`/v1/emision/catalogo-cancelacion`, config).then((response) => {
            this.motivos = response.data.map(m => m.motivo_cancelacion);
        });
    }
  }
};
</script>
